import { subDays } from 'date-fns';

export interface DisputeAuditLogEntry {
  id: string;
  date: Date;
  event: 'created' | 'updated' | 'activated' | 'deactivated' | 'deleted' | 'workflow_changed' | 'configuration_changed';
  user: {
    name: string;
    id: string;
  };
  details?: string;
}

export function generateDisputeAuditLog(disputeTypeId: string): DisputeAuditLogEntry[] {
  // Generate audit log based on dispute type ID
  const auditLogs: Record<string, DisputeAuditLogEntry[]> = {
    '1': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 2),
        event: 'workflow_changed',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Updated Level 2 escalation days from 8 to 10',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 7),
        event: 'configuration_changed',
        user: {
          name: 'John Smith',
          id: 'user-2',
        },
        details: 'Changed assigned user for Level 1',
      },
      {
        id: 'audit-3',
        date: subDays(new Date(), 15),
        event: 'workflow_changed',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Added Level 3 to workflow',
      },
      {
        id: 'audit-4',
        date: subDays(new Date(), 30),
        event: 'created',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Initial dispute type created',
      },
    ],
    '2': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 1),
        event: 'configuration_changed',
        user: {
          name: 'Mike Chen',
          id: 'user-3',
        },
        details: 'Updated document template for Level 2',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 5),
        event: 'workflow_changed',
        user: {
          name: 'Emma Williams',
          id: 'user-4',
        },
        details: 'Modified follow-up days for Level 3',
      },
      {
        id: 'audit-3',
        date: subDays(new Date(), 12),
        event: 'workflow_changed',
        user: {
          name: 'Mike Chen',
          id: 'user-3',
        },
        details: 'Added Level 4 to workflow',
      },
      {
        id: 'audit-4',
        date: subDays(new Date(), 25),
        event: 'created',
        user: {
          name: 'Mike Chen',
          id: 'user-3',
        },
        details: 'Initial dispute type created',
      },
    ],
    '3': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 3),
        event: 'configuration_changed',
        user: {
          name: 'David Martinez',
          id: 'user-5',
        },
        details: 'Changed escalation user for Level 1',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 10),
        event: 'workflow_changed',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Updated escalation timeline',
      },
      {
        id: 'audit-3',
        date: subDays(new Date(), 20),
        event: 'created',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Initial dispute type created',
      },
    ],
    '4': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 1),
        event: 'workflow_changed',
        user: {
          name: 'John Smith',
          id: 'user-2',
        },
        details: 'Modified Level 3 description',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 8),
        event: 'configuration_changed',
        user: {
          name: 'Emma Williams',
          id: 'user-4',
        },
        details: 'Updated document templates across all levels',
      },
      {
        id: 'audit-3',
        date: subDays(new Date(), 18),
        event: 'workflow_changed',
        user: {
          name: 'John Smith',
          id: 'user-2',
        },
        details: 'Added Level 5 to workflow',
      },
      {
        id: 'audit-4',
        date: subDays(new Date(), 35),
        event: 'created',
        user: {
          name: 'John Smith',
          id: 'user-2',
        },
        details: 'Initial dispute type created',
      },
    ],
    '5': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 4),
        event: 'configuration_changed',
        user: {
          name: 'Mike Chen',
          id: 'user-3',
        },
        details: 'Changed assigned user for Level 2',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 14),
        event: 'created',
        user: {
          name: 'Mike Chen',
          id: 'user-3',
        },
        details: 'Initial dispute type created',
      },
    ],
    '6': [
      {
        id: 'audit-1',
        date: subDays(new Date(), 2),
        event: 'workflow_changed',
        user: {
          name: 'David Martinez',
          id: 'user-5',
        },
        details: 'Updated escalation days for Level 2',
      },
      {
        id: 'audit-2',
        date: subDays(new Date(), 9),
        event: 'configuration_changed',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Modified document template',
      },
      {
        id: 'audit-3',
        date: subDays(new Date(), 22),
        event: 'created',
        user: {
          name: 'Sarah Johnson',
          id: 'user-1',
        },
        details: 'Initial dispute type created',
      },
    ],
  };

  // Return audit log for the specific dispute type, or default entries
  return auditLogs[disputeTypeId] || [
    {
      id: 'audit-1',
      date: subDays(new Date(), 7),
      event: 'created',
      user: {
        name: 'System',
        id: 'system',
      },
      details: 'Initial dispute type created',
    },
  ];
}
